import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonPage,
  IonRouterLink,
  IonTitle,
  IonToolbar,
} from '@ionic/react'
import axios from 'axios'
import { eyeOff, eye, at } from 'ionicons/icons'
import { RefObject, useRef, useState } from 'react'
import { animationBuilder, pageTransition } from '../../../App'
import API from '../../../utils/API'
import { useHistory } from 'react-router';
import styles from './SignUp.module.css' // Import css modules stylesheet as styles
import AuthProvider from '../../../AuthProvider/AuthProvider'
import React from 'react'
import { register } from '../../../serviceWorkerRegistration'

const Signup: React.FC = () => {
  /*
    useState<string | undefined | null>("");
    because event.detail.value might be a string or it can be null or undefined
  */

  const [email, setEmail] = useState<string | undefined | null>('')
  const [password, setPassword] = useState<string | undefined | null>('')
  const [passwordfocused, setPasswordFocused] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [confirmPassword, setConfirmPassword] = useState<string | undefined | null>('')
  const [confirmPasswordfocused, setConfirmPasswordFocused] = useState<boolean>(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false)
  const [userName, setUserName] = useState<string | undefined | null>('')
  const [number, setNumber] = useState<number | undefined | null>(0)



  const { register } = React.useContext(AuthProvider);

  function togglePassword() {
    setShowPassword(!showPassword)
  }

  function toggleConfirmPassword() {
    setShowConfirmPassword(!showConfirmPassword)
  }
  const history = useHistory();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

    event.preventDefault();
    event.stopPropagation();
    console.log({ email })
    console.log({ password })
    
    if(email && password){
      let result = await register({ email: email, password: password });
      if(result){
        console.log(result)
        console.log('successfully registered')
        history.replace("/signin");
      } else {
        console.log('Could not sign up')
      }
    } else {
      console.log('either email or password does not exist');
    }
  }


  const nextPage = async (
    enteringElement: RefObject<HTMLIonContentElement>,
    leavingElement: RefObject<HTMLIonContentElement>,
  ) => {
    await pageTransition({
      enteringEl: enteringElement.current!,
      leavingEl: leavingElement.current!,
      direction: 'forward',
    }).play()
  }

  const signUpRef = useRef<HTMLIonContentElement>(null)
  const photoUploadRef = useRef<HTMLIonContentElement>(null)
  const userNameRef = useRef<HTMLIonContentElement>(null)
  const numberRef = useRef<HTMLIonContentElement>(null)

  const signUp = () => {
    
    return (
        <IonList className={`${styles.transparentbg}`}>
          <IonListHeader lines='full'>
            <IonLabel class='ion-text-center' color='white'>
              What&apos;s good!
            </IonLabel>
          </IonListHeader>
          <form
           onSubmit={(e) => {
            handleSubmit(e)
          }}> 
          <div className='flex flex-col'>
            <div className='mb-8  mx-6 text-center text-white'>
              Big hyped to have you here!
            </div>
            <div className="ion-padding">
            <IonItem>
              <IonLabel position='floating'>Email</IonLabel>
              <IonInput
                autocomplete='email'
                clearInput={true}
                inputmode='email'
                enterkeyhint='next'
                type='email'
                value={email}
                onIonChange={(e) => setEmail(e.detail.value)}
                required
              ></IonInput>
            </IonItem>
            <IonItem className='items-end'>
              <IonLabel position='floating'>Password</IonLabel>
              <IonInput
                onIonFocus={() => setPasswordFocused(true)}
                onIonBlur={() => setPasswordFocused(false)}
                id='passwordEnter'
                class='passwordEnter'
                autocomplete='current-password'
                clearOnEdit={true}
                inputmode='text'
                enterkeyhint='go'
                type={showPassword ? 'text' : 'password'}
                value={password}
                onIonChange={(e) => setPassword(e.detail.value)}
                required
              ></IonInput>
              {passwordfocused && password !== "" ? (
                <IonIcon
                  slot='end'
                  className='cursor-pointer transition select-none animate__animated animate__fadeIn focus:select-none hover:text-gray-200 focus:text-gray-600 focus:text-opacity-50 text-white'
                  onClick={() => togglePassword()}
                  icon={showPassword ? eyeOff : eye}
                />
              ) : 
              <IonIcon
              slot='end'
              className='transition opacity-0'
              icon={showPassword ? eyeOff : eye}
            />
              }
            </IonItem>
            <IonItem className='items-end'>
              <IonLabel position='floating'>Confirm Password</IonLabel>
              <IonInput
                onIonFocus={() => setConfirmPasswordFocused(true)}
                onIonBlur={() => setConfirmPasswordFocused(false)}
                id='confirmPasswordEnter'
                class='passwordEnter'
                autocomplete='current-password'
                clearOnEdit={true}
                inputmode='text'
                enterkeyhint='go'
                type={showConfirmPassword && confirmPassword !== "" ? 'text' : 'password'}
                value={confirmPassword}
                onIonChange={(e) => setConfirmPassword(e.detail.value)}
                required
              ></IonInput>
              {confirmPasswordfocused ? (
                <IonIcon
                  slot='end'
                  className='cursor-pointer transition select-none animate__animated animate__fadeIn focus:select-none hover:text-gray-200 focus:text-gray-600 focus:text-opacity-50 text-white'
                  onClick={() => toggleConfirmPassword()}
                  icon={showConfirmPassword ? eyeOff : eye}
                />
              ) : 
              <IonIcon
              slot='end'
              className='opacity-0 transition'
              icon={showConfirmPassword ? eyeOff : eye}
            />
              }
            </IonItem>
            </div>
            <div className='flex justify-center mt-6'>
            <input type="submit" className={`${styles['submit-enter']}`} />                
            <IonButton
              expand='block'
                size='large'
                type="submit"
                className='flex mt-24 font-bold transition cursor-pointer select-none focus:select-none hover:text-gray-100 focus:text-opacity-50'
                color='white'
                fill='clear'
                disabled={confirmPassword === password ? false : true}
              >
                Continue
              </IonButton>
            </div>
          </div>
          </form>
        </IonList>
    )
  }

  const photoUpload = () => {
    return (
      <IonContent fullscreen ref={photoUploadRef} style={{ display: 'none' }}>
        <p className='ion-text-center text-white font-bold m-8 pt-10 text-5xl'>Welcome!</p>
        <p className='ion-text-center text-white font-medium m-6 mt-5 text-md'>
          We need a little information from you to help other people get to know you. Let&apos;s
          start by picking a profile picture.
        </p>
        <img
          src={process.env.PUBLIC_URL + '/assets/icon/PhotoUpload.png'}
          className='w-64 sm:w-24 md:w-32 lg:w-36 my-8 flex mx-auto'
          alt='logo'
        />
        <div className='ion-margin-horizontal'></div>
        <IonButton
          className='flex ion-margin-top ion-margin-horizontal t-8 font-bold'
          color='dark'
          fill='outline'
        >
          <div className='text-white'>Upload Photo</div>
        </IonButton>
        <div className='flex justify-center mt-6'>
          <IonButton
            expand='block'
            size='large'
            onClick={() => {
              nextPage(userNameRef, photoUploadRef)
            }}
            className='flex mt-24 font-bold transition cursor-pointer select-none focus:select-none hover:text-gray-100 focus:text-opacity-50'
            color='white'
            fill='clear'
          >
            Continue
          </IonButton>
        </div>
      </IonContent>
    )
  }

  const userNameComponent = () => {
    return (
      <IonContent ref={userNameRef} style={{ display: 'none' }}>
        <p className='ion-text-center text-white font-bold m-8 pt-10 text-5xl'>Make it yours</p>
        <p className='ion-text-center text-white font-medium m-6 mt-5 text-md'>
          This one is mandatory. Pick a username. We&apos;ll leave the creativity to you.
        </p>
        <div className='ion-margin-horizontal'></div>
        <div className="ion-padding">
        <IonItem className='items-end'>
          <IonLabel position='floating'>UserName</IonLabel>
          <IonIcon
            slot='start'
            className='cursor-pointer select-none animate__animated animate__fadeIn focus:select-none hover:text-gray-200 focus:text-gray-600 focus:text-opacity-50'
            icon={at}
          />
          <IonInput
            id='userNameEnter'
            class='passwordEnter'
            clearOnEdit={true}
            inputmode='text'
            enterkeyhint='go'
            type='text'
            value={userName}
            onIonChange={(e) => setUserName(e.detail.value)}
            required
          ></IonInput>
        </IonItem>
        <p className='ion-text-end font-small m-6 text-s text-white'>Taken</p>
        </div>
        <div className='flex justify-center mt-6'>
          <IonButton
            expand='block'
            size='large'
            onClick={() => {
              nextPage(numberRef, userNameRef)
            }}
            className='flex mt-24 font-bold transition cursor-pointer select-none focus:select-none hover:text-gray-100 focus:text-opacity-50'
            color='white'
            fill='clear'
          >
            Continue
          </IonButton>
        </div>
      </IonContent>
    )
  }

  const numberEntry = () => {
    return (
      <IonContent ref={numberRef} style={{ display: 'none' }}>
        <p className='ion-text-center text-white font-bold m-8 pt-10 text-5xl'>My number is</p>
        <div className="ion-padding">
        <IonItem className='items-end'>
          <IonLabel position='floating'>Phone Number</IonLabel>
          <IonInput
            id='numberEntry'
            class='passwordEnter'
            clearOnEdit={true}
            inputmode='text'
            enterkeyhint='go'
            type='number'
            value={number}
            onIonChange={(e) => setNumber(parseInt(e.detail.value!))}
            required
          ></IonInput>
        </IonItem>
        </div>
        <div className='ion-margin-horizontal'>
          <p className='ion-text-center text-white font-medium m-6 mt-10 pt-12 text-sm'>
            When you tap Continue, We will send a text with a verification code. Message and data
            rates may apply. The verified phone number can be used to login.{' '}
            <a href='#' className='underline'>Learn what happens when your number changes.</a>
          </p>
        </div>
        <div className='flex justify-center mt-6'>
          <IonRouterLink
            routerAnimation={animationBuilder}
            routerLink='/timeline'
            routerDirection='forward'
          >
            <IonButton
              expand='block'
              size='large'

              className='flex mt-24 font-bold transition cursor-pointer select-none focus:select-none hover:text-gray-100 focus:text-opacity-50'
              color='white'
              fill='clear'
            >
              Continue
            </IonButton>
          </IonRouterLink>
        </div>
      </IonContent>
    )
  }

  return (
    <IonPage className={`${styles.bg}`}>
      <IonHeader>
        <IonToolbar  color="primary">
          <IonButtons slot='start'>
            <IonBackButton text='' color='white'/>
          </IonButtons>
          <IonTitle color='white'>New account</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {signUp()}
        {photoUpload()}
        {userNameComponent()}
        {numberEntry()}
      </IonContent>
    </IonPage>
  )
}

export default Signup
